/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import {NotificationProps} from "./notificationsPage";

type RetType = [(value: string) => void];

export default function useDefaultNotification(props: NotificationProps): RetType {
    const {notification, onChangeNotification} = props;

    function onChangeEmailAddresses(value: string) {
        notification.emailAddresses = value.split(',');
        onChangeNotification(notification);
    }

    return [onChangeEmailAddresses]
}